// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataceur } from "../../../icons/mono/build/icon-stataceur.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataceurIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataceur.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataceurIcon.displayName = 'StataceurIcon';
}

export default StataceurIcon;